export default {
      id: "calendar-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#calendar",
      toString: function () {
        return this.url;
      }
    }